import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-check-circle-outline",
  "use": "icon-check-circle-outline-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol viewBox=\"0 0 28 28\" id=\"icon-check-circle-outline\"><path d=\"M14 0c7.8 0 14 6.2 14 14s-6.2 14-14 14S0 21.8 0 14 6.2 0 14 0m0 2C7.4 2 2 7.4 2 14s5.4 12 12 12 12-5.4 12-12S20.6 2 14 2m4.858 5.615L20.723 8.9l-7.95 12.75L7.4 16.063l1.445-1.933 3.577 3.37z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol